import login from './login';
import message from './message';
// import closure from './pos/closure/posClosure';

const reducers = {
  login,
  message,
  //receipt,
  //closure,
};

export default reducers;
